import { ActionTile } from "@fullscript/aviary-web";

import * as styles from "../RegionSelectorPage.styles";

interface Props {
  label: string;
  content: string;
  icon: Parameters<typeof ActionTile>[0]["icon"];
  href: string;
}

const RegionTile = ({ label, content, icon, href }: Props) => (
  <a href={href} css={styles.form}>
    <ActionTile
      label={label}
      content={content}
      icon={icon}
      showBorder
      intention="accentGreen"
      customCss={styles.tile}
      type="button"
    />
  </a>
);

export { RegionTile };
